"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var picker_service_1 = require("./picker.service");
var utils_1 = require("./utils");
var black = '#000000';
var white = '#FFFFFF';
var grey = '#dddddd';
var HighlightCalendarDirective = (function () {
    function HighlightCalendarDirective(el, renderer, service) {
        this.el = el;
        this.renderer = renderer;
        this.service = service;
        this.originalDayColor = black;
        this.themeColor = this.service.dtTheme;
        this.themeLightColor = utils_1.shadeBlendConvert(0.7, this.themeColor);
    }
    HighlightCalendarDirective.prototype.ngOnChanges = function (changes) {
        if (changes['day'] && changes['day'].currentValue) {
            if (!this.service.isValidDate(this.day)) {
                this.originalDayColor = grey;
                this.renderer.addClass(this.el.nativeElement, 'picker-day-invalid');
            }
            if (this.isOutFocus()) {
                this.originalDayColor = grey;
                this.renderer.addClass(this.el.nativeElement, 'picker-day-out-focus');
            }
            this.highlight('transparent', this.originalDayColor);
        }
        if (this.month && changes['calendarMoment'] &&
            changes['calendarMoment'].currentValue) {
            if (this.isCalendarMonth()) {
                this.highlight(this.themeColor, white);
                this.renderer.addClass(this.el.nativeElement, 'picker-month-current');
            }
            else {
                this.highlight('transparent', black);
                this.renderer.removeClass(this.el.nativeElement, 'picker-month-current');
            }
        }
        if (this.year && changes['calendarMoment'] &&
            changes['calendarMoment'].currentValue) {
            if (this.isCalendarYear()) {
                this.highlight(this.themeColor, white);
                this.renderer.addClass(this.el.nativeElement, 'picker-year-current');
            }
            else {
                this.highlight('transparent', black);
                this.renderer.removeClass(this.el.nativeElement, 'picker-year-current');
            }
        }
    };
    HighlightCalendarDirective.prototype.ngOnInit = function () {
        var _this = this;
        this.subId = this.service.selectedMomentChange.subscribe(function (data) {
            _this.selectedMoment = data;
            _this.highlightSelectedDay();
        });
    };
    HighlightCalendarDirective.prototype.ngOnDestroy = function () {
        this.subId.unsubscribe();
    };
    HighlightCalendarDirective.prototype.onMouseEnter = function () {
        if (!this.service.isValidDate(this.day) ||
            this.service.isTheSameDay(this.day, this.selectedMoment) ||
            this.isCalendarMonth() ||
            this.isCalendarYear()) {
            return;
        }
        this.highlight(this.themeLightColor, black);
    };
    HighlightCalendarDirective.prototype.onMouseLeave = function () {
        if (!this.service.isValidDate(this.day) ||
            this.service.isTheSameDay(this.day, this.selectedMoment) ||
            this.isCalendarMonth() ||
            this.isCalendarYear()) {
            return;
        }
        var color = this.isOutFocus() ? grey : black;
        this.highlight('transparent', color);
    };
    HighlightCalendarDirective.prototype.isCalendarMonth = function () {
        return this.month && this.calendarMoment &&
            this.month === this.calendarMoment.locale(this.service.dtLocale).format('MMM');
    };
    HighlightCalendarDirective.prototype.isCalendarYear = function () {
        return this.year && this.calendarMoment && this.year === this.calendarMoment.format('YYYY');
    };
    HighlightCalendarDirective.prototype.isOutFocus = function () {
        return this.day && this.calendarMoment && !this.day.isSame(this.calendarMoment, 'month');
    };
    HighlightCalendarDirective.prototype.highlight = function (bgColor, color) {
        this.renderer.setStyle(this.el.nativeElement, 'backgroundColor', bgColor);
        this.renderer.setStyle(this.el.nativeElement, 'color', color);
    };
    HighlightCalendarDirective.prototype.highlightSelectedDay = function () {
        if (this.selectedElm) {
            this.highlight('transparent', this.originalDayColor);
            this.renderer.removeClass(this.selectedElm.nativeElement, 'picker-day-selected');
            this.selectedElm = null;
        }
        if (this.service.isTheSameDay(this.day, this.selectedMoment)) {
            this.highlight(this.themeColor, white);
            this.renderer.addClass(this.el.nativeElement, 'picker-day-selected');
            this.selectedElm = this.el;
        }
    };
    return HighlightCalendarDirective;
}());
HighlightCalendarDirective.decorators = [
    { type: core_1.Directive, args: [{
                selector: '[pickerCalendarHighlight]'
            },] },
];
HighlightCalendarDirective.ctorParameters = function () { return [
    { type: core_1.ElementRef, },
    { type: core_1.Renderer2, },
    { type: picker_service_1.PickerService, },
]; };
HighlightCalendarDirective.propDecorators = {
    'day': [{ type: core_1.Input },],
    'month': [{ type: core_1.Input },],
    'year': [{ type: core_1.Input },],
    'calendarMoment': [{ type: core_1.Input },],
    'onMouseEnter': [{ type: core_1.HostListener, args: ['mouseenter',] },],
    'onMouseLeave': [{ type: core_1.HostListener, args: ['mouseleave',] },],
};
exports.HighlightCalendarDirective = HighlightCalendarDirective;
//# sourceMappingURL=highlight-calendar.directive.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/ng-pick-datetime/highlight-calendar.directive.js
// module id = ../../../../ng-pick-datetime/highlight-calendar.directive.js
// module chunks = 15